import { render, staticRenderFns } from "./CurrencySmart.vue?vue&type=template&id=047359b2"
import script from "./CurrencySmart.vue?vue&type=script&lang=js"
export * from "./CurrencySmart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports